import { createSlice } from '@reduxjs/toolkit';
import { makePropertyReducer } from 'store/utils';
import { GeoDiscountState } from './types';

const getPropertyReducer = makePropertyReducer<GeoDiscountState>();

const initialState: GeoDiscountState = {
  billingCountry: '',
  cookieCountry: '',
  currentGeoDiscount: {
    code: '',
    discountId: '',
    percentage: '',
  },
  isAutoApplied: false,
  isValidating: false,
};

const geoDiscountSlice = createSlice({
  name: 'geoDiscount',
  initialState,
  reducers: {
    ...getPropertyReducer('billingCountry'),
    ...getPropertyReducer('cookieCountry'),
    ...getPropertyReducer('currentGeoDiscount'),
    ...getPropertyReducer('isAutoApplied'),
    ...getPropertyReducer('isValidating'),
  },
});

const {
  actions: {
    setBillingCountry,
    setCookieCountry,
    setCurrentGeoDiscount,
    setIsAutoApplied,
    setIsValidating,
  },
  reducer: geoDiscountReducer,
} = geoDiscountSlice;

export {
  setBillingCountry,
  setCookieCountry,
  setCurrentGeoDiscount,
  setIsAutoApplied,
  setIsValidating,
  geoDiscountReducer,
};
